
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import SubmissionFormHeader from '../SubmissionFormHeader';

interface FormHeaderProps {
}

const FormHeader: React.FC<FormHeaderProps> = () => {
  return (
    <Card>
      <CardContent className="p-6">
        <SubmissionFormHeader />
      </CardContent>
    </Card>
  );
};

export default FormHeader;
